module.exports = __webpack_public_path__ + "3610935577098a10b62a93f54e49446f.svg";